

































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public packageInfo;
  @Prop({
    type: Number,
    default: 1,
  })
  public active;
  @Prop({
    type: Number,
    default: 1,
  })
  public id;
  public download(item) {
    if (item.engine_type == 2 && item.name_type == 2 && item.edition == "引擎下载") {
      this.$emit("download", item.id);
    } else {
      window.open(item.download_link, "_blank");
    }
  }
  public openNews() {
    window.open("https://996m2.com/news/detail?id=5", "_blank");
  }
}
